import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../hooks/useLanguage';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[90vh] flex items-center justify-center px-4 py-20 overflow-hidden" data-id="element-82">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#D4A843]/10 via-[#0A0A0F]/50 to-[#0A0A0F] pointer-events-none" data-id="element-83" />
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 pointer-events-none mix-blend-overlay" data-id="element-84" />

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#D4A843]/10 border border-[#D4A843]/20 text-[#D4A843] text-sm font-semibold tracking-wide mb-8" data-id="element-86">
          <span className="w-2 h-2 rounded-full bg-[#D4A843] animate-pulse" data-id="element-87" />
          {t('hero_badge')}
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-6 tracking-tight" data-id="element-88">
          {t('hero_h1_before')}{' '}
          <span className="text-[#D4A843] text-glow" data-id="element-89">
            {t('hero_h1_highlight')}
          </span>{' '}
          {t('hero_h1_after')}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-300 mb-8 font-medium max-w-2xl mx-auto" data-id="element-90">
          {t('hero_subtitle_before')}{' '}
          <span className="text-white font-semibold" data-id="element-91">
            {t('hero_subtitle_highlight')}
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center gap-4" data-id="element-92">
          <p className="text-gray-400 text-lg mb-2" data-id="element-93">{t('hero_supporting')}</p>

          <Button size="xl" className="w-full md:w-auto text-lg md:text-xl shadow-[0_0_40px_rgba(212,168,67,0.4)]" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-94">
            {t('hero_cta')}
            <ArrowRight className="ml-2 h-6 w-6" data-id="element-95" />
          </Button>

          <div className="flex items-center gap-2 text-sm text-gray-500 mt-2" data-id="element-96">
            <CheckCircle2 className="w-4 h-4 text-[#D4A843]" data-id="element-97" />
            <span data-id="element-98">{t('hero_price')}</span>
            <span className="mx-2" data-id="element-99">•</span>
            <span className="text-[#DC2626] font-medium" data-id="element-100">
              {t('hero_urgency')}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}